type TPagePostType = 'category_page' | 'other_pages'

export function pushPagePostTypeToDataLayer(pagePostType : TPagePostType) {
  if (!process.client) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ pagePostType });
}
